import styled from 'styled-components';
import { SemanticUI } from '@iterable/deprecated_react_components';
import { pxToRem } from 'utils/convert';
import { CheckableOption } from 'ui/selects';
import { CounterBadge } from 'ui/badge';
import { Body2, colors } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';

export const StyledCheckableOption = styled(CheckableOption)`
  padding: 0;
  pointer-events: all;
`;

export const SecondaryOptionText = styled(Body2)`
  color: ${colors.textSecondary};
`;

export const SelectTriggerWrapper = styled.div`
  ${({ isSet }) =>
    isSet
      ? `
    // Without this the height of the badge messes up the height of the dropdown
    position: absolute;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
  `
      : ''};
`;

export const StyledCounterBadge = styled(CounterBadge)`
  margin-left: ${pxToRem(6)};
`;

export const StyledMultiSelectDropdown = styled(SemanticUI.Dropdown)`
  &&&& {
    display: flex;
    flex: 1 1 auto;
    [data-role='queryBuilder'][data-view-mode='true'] {
      display: none !important;
    }
    &&&&&.ui.dropdown.fluid {
      margin-bottom: 0;
      position: relative;
      .menu {
        > .divider {
          margin-top: 0;
          margin-bottom: 0;
        }
      }
      .menu.transition.visible.outer {
        overflow-y: hidden;
        display: flex !important;
        flex-direction: column;
        > .input,
        > .divider {
          flex: 0 0 auto;
        }
        > .menu {
          flex: 1 1 100%;
        }
      }
    }
  }
`;

export const StyledTopTooltip = styled(Tooltip)`
  width: 100%;
  > span {
    width: 100%;
  }
`;
export const SelectedValue = styled.div`
  margin-bottom: ${pxToRem(5)};
`;
export const FlexSelectValue = styled.div`
  display: flex;
  flex-direction: column;
  `;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};
`;

export const StyledOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
